import { Link } from "react-router-dom";

export interface GamePastItem {
  no: number;
  to: string;
  icon?: string;
  title: string;
  meta?: string;
}

interface Props {
  items: GamePastItem[];
  /** 섹션 위쪽 라벨 (예: 지난 판 / 지난 모임 / 지난 경기) */
  title?: string;
  /** 지난 기록이 하나도 없을 때 문구 */
  emptyText?: string;
}

// 메인 홈 «빈 상태» 오른쪽에 붙는 지난 기록 썸네일 가로 스크롤.
// 판이 열리지 않았을 때도 섹션을 억지로 키우지 않고 가볍게 몇 개만 보여준다.
export default function GamePastStrip({
  items,
  title = "지난 판",
  emptyText = "아직 지난 기록이 없습니다.",
}: Props) {
  return (
    <div className="min-w-0 flex-1">
      <p className="mb-3 flex items-center gap-1.5 text-xs font-semibold text-foreground-400">
        <i className="ri-history-line" aria-hidden="true"></i>
        {title}
      </p>

      {items.length === 0 ? (
        <p className="rounded-lg border border-dashed border-background-200 px-4 py-6 text-center text-xs text-foreground-400">
          {emptyText}
        </p>
      ) : (
        <div className="flex gap-3 overflow-x-auto pb-1">
          {items.map((it) => (
            <Link
              key={it.no}
              to={it.to}
              className="group flex w-[200px] shrink-0 flex-col gap-1.5 rounded-lg border border-background-200 bg-background-100/70 p-3 transition-colors hover:border-primary-300 hover:bg-background-100"
            >
              <span
                className="flex items-center gap-1.5 text-xs font-semibold text-foreground-400"
                aria-hidden="true"
              >
                {it.icon ?? "🗂️"}
              </span>
              <p className="truncate font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-700">
                {it.title}
              </p>
              {it.meta ? (
                <p className="truncate text-xs text-foreground-500">{it.meta}</p>
              ) : null}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}